import {Component, EventEmitter, inject, Input, OnInit, Output, ViewChild} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {CountriesService, Country} from '../../service/countries.service';
import {LowerCasePipe} from '@angular/common';
import {FormsModule, ReactiveFormsModule, UntypedFormGroup} from '@angular/forms';
import {DividerModule} from 'primeng/divider';
import {Select} from 'primeng/select';

@Component({
  selector: 'app-country-dropdown',
  standalone: true,
  imports: [
    TranslatePipe,
    LowerCasePipe,
    FormsModule,
    DividerModule,
    Select,
    ReactiveFormsModule
  ],
  templateUrl: './country-dropdown.component.html',
  styleUrl: './country-dropdown.component.scss'
})
export class CountryDropdownComponent implements OnInit
{
  private countriesService = inject(CountriesService);

  @ViewChild('countrySelect') countrySelect!: Select;

  countries: Country[];
  @Input() selectedCountry: Country;
  @Output() selectedCountryValue = new EventEmitter<Country>();

  @Input() selectedCountryCd: string;
  @Output() selectedCountryCdChange = new EventEmitter<string>();
  @Input() initGermany: boolean;

  @Input() showClear: boolean;
  @Input() placeholder = 'PLEASE_SELECT';

  @Input() valueType: string;
  @Input() fieldName: string;
  @Input() form: UntypedFormGroup;

  scrollHeight = '200px';

  ngOnInit(): void
  {
    this.countries = this.countriesService.getCountries();
    if (this.countries?.length > 0)
    {
      if (this.initGermany)
      {
        this.selectedCountry = this.countries[0];
        this.selectedCountryValue.emit(this.selectedCountry);
        // this.selectedCountryCdChange.emit(this.selectedCountry.code);
      }
      else if (this.selectedCountryCd)
      {
        for (const country of this.countries)
        {
          if (country.code === this.selectedCountryCd)
          {
            this.selectedCountry = country;
            this.selectedCountryValue.emit(this.selectedCountry);
            // this.selectedCountryCdChange.emit(this.selectedCountry.code);
            break;
          }
        }
      }
    }
    console.log('[CountryDropdownComponent.ts], selectedCountry: ', this.selectedCountry, this.countries);
  }

  public onSelectShow(): void
  {
    const element = this.countrySelect?.el?.nativeElement;
    if (element)
    {
      const rect = element.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;
      let availableHeight = Math.max(spaceBelow, spaceAbove) - 16;
      if (availableHeight > 400)
        availableHeight = 400;

      this.scrollHeight = `${Math.max(100, availableHeight)}px`;
      console.log('scrollHeight: ' + this.scrollHeight);
    }
  }

  public countryChanged(event: any): void
  {
    if (this.form && this.fieldName)
    {
      for (const country of this.countries)
      {
        if (country.code === this.selectedCountryCd)
          this.selectedCountry = country;
      }
    }

    if (this.selectedCountry?.code === '--' && this.countries?.length > 0)
    {
      this.selectedCountry = this.countries[0];
      setTimeout(() => this.selectedCountry = this.countries[0]);
    }
    console.log('countryChanged', this.selectedCountry);
    this.selectedCountryValue.emit(this.selectedCountry);
    this.selectedCountryCdChange.emit(this.selectedCountry?.code);
  }
}
